// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".model-table .head {\n  height: 31.25rem;\n}\n.radio .el-radio__label {\n  font-size: 0;\n}\n.ceshi {\n  font-size: 2rem;\n}\n.model-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 2.5rem;\n}\n.title .el-form-item--mini {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
